const QEWD_DIGEST_INITIAL_STATE = {
	thumbnails: [],
};

export default QEWD_DIGEST_INITIAL_STATE;
